import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectCurrentUser } from './AuthSelector';
import { selectAppConfig } from './AppSelector';

function getProductData(appConfig) {
  return {
    'bc.product': 'core',
    'bc.version': appConfig.get('appVersion')
  };
}

function getUserData(user) {
  if (user) {
    return {
      'bc.encodedUserId': user.get('encodedId')
    };
  }

  return {};
}

function getSiteData(state) {
  return state.getIn(['analytics', 'siteDataLayer'], Immutable.Map());
}

function getContextData(state) {
  return {
    context: state.getIn(['analytics', 'context'], Immutable.Map())
  };
}

export const selectDataLayer = createSelector(
  [getSiteData, getContextData, selectCurrentUser, selectAppConfig],
  (siteData, context, user, appConfig) => {
    const userData = getUserData(user);
    const productData = getProductData(appConfig);
    return siteData.merge(context, userData, productData);
  }
);

export default {
  selectDataLayer
};
